import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import ConfirmDialogue from "../modules/components/ConfirmDialogue";

export default function LogoutDialog({ open, onClose }) {
  const { logout }  = useContext(AuthContext);
  const navigate    = useNavigate();

  const handleConfirm = () => {
    logout();
    navigate("/login", { replace: true });
  };

  return (
    <ConfirmDialogue
      open={open}
      title="Sign out"
      message="Are you sure you want to sign out of SwiftReach?"
      confirmLabel="Sign out"
      cancelLabel="Cancel"
      danger
      onConfirm={handleConfirm}
      onCancel={onClose}
    />
  );
}
